export enum SchoolLessonType {
  Unknown = 0,
  First = 1,
  Regular = 2,
  Exam = 3,
}
